import { render, staticRenderFns } from "./VendorSelector.vue?vue&type=template&id=1d16e002&scoped=true&"
import script from "./VendorSelector.vue?vue&type=script&lang=js&"
export * from "./VendorSelector.vue?vue&type=script&lang=js&"
import style0 from "./VendorSelector.vue?vue&type=style&index=0&id=1d16e002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d16e002",
  null
  
)

export default component.exports